import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetFlatChargeTypesQueryVariables = Types.Exact<{
  activeOnly?: Types.Scalars['Boolean']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.FlatChargeTypeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.FlatChargeTypeDocumentSortInput> | Types.FlatChargeTypeDocumentSortInput>;
}>;


export type GetFlatChargeTypesQuery = { __typename?: 'Query', flatChargeTypes?: { __typename?: 'FlatChargeTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'FlatChargeTypeDocument', id: string, flatChargeTypeId: string, name: string, taxable: boolean, accountId?: string | null, isActive: boolean, account?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type FlatChargeTypeRowFragment = { __typename?: 'FlatChargeTypeDocument', id: string, flatChargeTypeId: string, name: string, taxable: boolean, accountId?: string | null, isActive: boolean, account?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null };

export const FlatChargeTypeRowFragmentDoc = new TypedDocumentString(`
    fragment FlatChargeTypeRow on FlatChargeTypeDocument {
  id
  flatChargeTypeId
  name
  taxable
  accountId
  isActive
  account {
    accountNumber
    name
  }
}
    `, {"fragmentName":"FlatChargeTypeRow"});
export const GetFlatChargeTypesDocument = new TypedDocumentString(`
    query GetFlatChargeTypes($activeOnly: Boolean! = false, $first: Int, $after: String, $where: FlatChargeTypeDocumentFilterInput, $order: [FlatChargeTypeDocumentSortInput!]) {
  flatChargeTypes(
    activeOnly: $activeOnly
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...FlatChargeTypeRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment FlatChargeTypeRow on FlatChargeTypeDocument {
  id
  flatChargeTypeId
  name
  taxable
  accountId
  isActive
  account {
    accountNumber
    name
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetFlatChargeTypes: build.query<GetFlatChargeTypesQuery, GetFlatChargeTypesQueryVariables | void>({
      query: (variables) => ({ document: GetFlatChargeTypesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetFlatChargeTypesQuery, useLazyGetFlatChargeTypesQuery } = injectedRtkApi;
